const BorderButton = (props) => {
    const { customClass, buttonType, title, children, disabled, onClick } = props
    return (
        <button
            type={buttonType}
            disabled={disabled}
            onClick={onClick}
            className={`${customClass} relative inline-flex items-center justify-center rounded-xl h-10 sm:px-6 px-5 2xl:text-sm text-xs font-semibold bg-white/80 backdrop-blur-sm border border-neutral-200 text-neutral-800 hover:bg-white hover:border-primary/40 hover:text-primaryDark hover:shadow-soft hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/20 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:pointer-events-none`}
        >
            {children ? children : title}
        </button>
    )
}

export default BorderButton
